import { Card } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Translate } from "../../../Enums/Tranlate";
import "./style.css";
import { useEffect, useState } from "react";
import EditEmployeeModal from "./EditEmployeeModal";
import { useLocation } from "react-router-dom";
import EmployeesService from "../../../../services/HRM/EmployeesService";

const EmployeeProfile = () => {
	const [modal, setModal] = useState(false);
	const [type, setType] = useState("");
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const lang = useSelector((state) => state.auth?.lang);
	const location = useLocation();
	const employeesService = new EmployeesService();

	useEffect(() => {
		let id = location?.pathname?.split("/")[2];
		employeesService.find(id).then((res) => {});
	}, []);

	return (
		<div className="employeeProfile mb-5">
			<div className="row">
				<div className="col-12 mb-3">
					<Card>
						<Card.Body>
							<div className="d-flex mb-3 justify-content-between">
								<h3 className="mb-0">{Translate[lang].personal_information}</h3>
								<i
									className="fa fa-pencil edit cursor-pointer"
									onClick={() => {
										setModal(true);
										setType("personal_information");
									}}
								/>
							</div>
							<div className="mb-4 d-flex gap-20">
								<i className="fa fa-user user" />
								<div>
									<p className="name">Muhammed</p>
									<p className="jobTitle mb-0">Frontend Develoer</p>
									<p className="Job mb-0">Web Designer</p>
									<p className="employeeId mb-0">Employee ID : MD-0001</p>
									<p className="dateJoin mb-0">Date of Join : 05 01 2024</p>
								</div>
							</div>
							<div>
								<div className="mb-3">
									<label>{Translate[lang].phone}:</label>
									<span>+1(800) 642 7676</span>
								</div>
								<div className="mb-3">
									<label>{Translate[lang].email}:</label>
									<span>ethanmitchell@example.com</span>
								</div>
								<div className="mb-3">
									<label>{Translate[lang].birthday}:</label>
									<span>28 December 1992</span>
								</div>
								<div className="mb-3">
									<label>{Translate[lang].address}:</label>
									<span>
										100 Terminal, Fort Lauderdale, Miami 33315, United States
									</span>
								</div>
								<div>
									<label>{Translate[lang].gender}:</label>
									<span>Male</span>
								</div>
							</div>
						</Card.Body>
					</Card>
				</div>
				<div className="col-6 mb-3">
					<Card>
						<Card.Body>
							<div className="d-flex mb-3 justify-content-between">
								<h3 className="mb-0">
									{Translate[lang].education_qualification}
								</h3>
								<i
									className="fa fa-pencil edit cursor-pointer"
									onClick={() => {
										setModal(true);
										setType("education_qualification");
									}}
								/>
							</div>
							<div className="position-relative">
								<div className="education-card mb-3">
									<p className="title">
										International College of Arts and Science (UG)
									</p>
									<p className="mb-0">MSc In Computer Science</p>
									<p className="m-0">2000 - 2003</p>
								</div>
								<div className="education-card mb-3">
									<p className="title">
										International College of Arts and Science (UG)
									</p>
									<p className="mb-0">MSc In Computer Science</p>
									<p className="m-0">2000 - 2003</p>
								</div>
								<div className="education-card mb-0">
									<p className="title">
										International College of Arts and Science (UG)
									</p>
									<p className="mb-0">MSc In Computer Science</p>
									<p className="m-0">2000 - 2003</p>
								</div>
							</div>
						</Card.Body>
					</Card>
				</div>
				<div className="col-6 mb-3">
					<Card>
						<Card.Body>
							<div className="d-flex mb-3 justify-content-between">
								<h3 className="mb-0">{Translate[lang].experience_details}</h3>
								<i
									className="fa fa-pencil edit cursor-pointer"
									onClick={() => {
										setModal(true);
										setType("experience_details");
									}}
								/>
							</div>
							<div className="position-relative">
								<div className="education-card mb-3">
									<p className="title">Envato Inc, Melbourne</p>
									<p className="mb-0">Head Of Review Team</p>
									<p className="m-0">2000 - 2003</p>
								</div>
								<div className="education-card mb-3">
									<p className="title">Envato Inc, Melbourne</p>
									<p className="mb-0">Head Of Review Team</p>
									<p className="m-0">2000 - 2003</p>
								</div>
								<div className="education-card mb-0">
									<p className="title">Envato Inc, Melbourne</p>
									<p className="mb-0">Head Of Review Team</p>
									<p className="m-0">2000 - 2003</p>
								</div>
							</div>
						</Card.Body>
					</Card>
				</div>
				<div className="col-4 mb-3">
					<Card>
						<Card.Body>
							<div className="d-flex mb-3 justify-content-between">
								<h3 className="mb-0">{Translate[lang].bank_account}</h3>
								<i
									className="fa fa-pencil edit cursor-pointer"
									onClick={() => {
										setModal(true);
										setType("bank_account");
									}}
								/>
							</div>
							<div>
								<div className="d-flex justify-content-between">
									<p className="fw-500">{Translate[lang].account_name}</p>
									<p>Ethan Mitchell</p>
								</div>
								<div className="d-flex justify-content-between">
									<p className="fw-500">{Translate[lang].account_number}</p>
									<p>123456789</p>
								</div>
								<div className="d-flex justify-content-between">
									<p className="fw-500 mb-0">{Translate[lang].account_name}</p>
									<p className="mb-0">ABC Bank</p>
								</div>
							</div>
						</Card.Body>
					</Card>
				</div>
				<div className="col-4 mb-3">
					<Card>
						<Card.Body>
							<div className="d-flex mb-3 justify-content-between">
								<h3 className="mb-0">{Translate[lang].passport_information}</h3>
								<i
									className="fa fa-pencil edit cursor-pointer"
									onClick={() => {
										setModal(true);
										setType("passport_information");
									}}
								/>
							</div>
							<div>
								<div className="d-flex justify-content-between">
									<p className="fw-500">{Translate[lang].passport_number}</p>
									<p>Ethan Mitchell</p>
								</div>
								<div className="d-flex justify-content-between">
									<p className="fw-500">{Translate[lang].nationality}</p>
									<p>123456789</p>
								</div>
								<div className="d-flex justify-content-between">
									<p className="fw-500">{Translate[lang].passport_no}</p>
									<p>123123</p>
								</div>
								<div className="d-flex justify-content-between">
									<p className="fw-500 mb-0">
										{Translate[lang].passport_expiry_date}
									</p>
									<p className="mb-0">123123</p>
								</div>
							</div>
						</Card.Body>
					</Card>
				</div>
				<div className="col-4 mb-3">
					<Card>
						<Card.Body>
							<div className="d-flex mb-3 justify-content-between">
								<h3 className="mb-0">{Translate[lang].social}</h3>
								<i
									className="fa fa-pencil edit cursor-pointer"
									onClick={() => {
										setModal(true);
										setType("social");
									}}
								/>
							</div>
							<div>
								<div className="d-flex justify-content-between">
									<p className="fw-500">{Translate[lang].linked_in}</p>
									<p>Muhammed</p>
								</div>
								<div className="d-flex justify-content-between">
									<p className="fw-500">{Translate[lang].telegram}</p>
									<p>123456789</p>
								</div>
								<div className="d-flex justify-content-between">
									<p className="fw-500 mb-0">{Translate[lang].tiktok}</p>
									<p className="mb-0">123123</p>
								</div>
							</div>
						</Card.Body>
					</Card>
				</div>
			</div>
			{modal && (
				<EditEmployeeModal
					modal={modal}
					setModal={setModal}
					type={type}
					setShouldUpdate={setShouldUpdate}
				/>
			)}
		</div>
	);
};
export default EmployeeProfile;
